// Rep commissions (admin). Monthly, payment-received based.
import { api } from './client.js';

export const fetchCommissions = (year, month) =>
  api.get('/commissions', { params: { year, month } }).then((r) => r.data);
export const setCommissionRate = (repUserId, rate) =>
  api.post('/commissions/rate', { repUserId, rate }).then((r) => r.data);
export const setCommissionCurrency = (repUserId, currency) =>
  api.post('/commissions/currency', { repUserId, currency }).then((r) => r.data);
// opts.override (admins only) pays without the rep's approval; opts.note says why.
export const settleCommission = (repUserId, year, month, opts = {}) =>
  api.post('/commissions/settle', { repUserId, year, month, ...opts }).then((r) => r.data);
export const unsettleCommission = (repUserId, year, month) =>
  api.post('/commissions/unsettle', { repUserId, year, month }).then((r) => r.data);

// Airwallex payouts: match beneficiaries to reps by email, and pay a rep's month via transfer.
export const syncBeneficiaries = () => api.post('/commissions/sync-beneficiaries').then((r) => r.data);
export const payCommission = (repUserId, year, month, opts = {}) =>
  api.post('/commissions/pay', { repUserId, year, month, ...opts }).then((r) => r.data);

// Monthly report emailed to a rep (admins get a copy), or to every rep who hasn't had it yet.
export const sendCommissionReport = (repUserId, year, month) =>
  api.post('/commissions/report', { repUserId, year, month }).then((r) => r.data);
// Re-send the "paid" email (with the remittance PDF) for a paid month.
export const resendPaidNotice = (repUserId, year, month) =>
  api.post('/commissions/paid-notice', { repUserId, year, month }).then((r) => r.data);
export const sendAllCommissionReports = (year, month) =>
  api.post('/commissions/reports', { year, month }).then((r) => r.data);

// The rep's side: approve the figure they were shown, or say something's not right.
export const approveMyCommission = (year, month, amount, currency) =>
  api.post('/me/commissions/approve', { year, month, amount, currency }).then((r) => r.data);
export const queryMyCommission = (year, month, note) =>
  api.post('/me/commissions/query', { year, month, note }).then((r) => r.data);

// A rep's own commission summary (this month accruing + settled/pending history).
export const fetchMyCommissions = () => api.get('/me/commissions').then((r) => r.data);
